<template>
  <div class="floating">
    <div class="floating-item" @click="goToAsk">
      <icon-base icon-name="chat" width="36" height="36" iconColor="#333" iconName="在线咨询">
        <icon-chat />
      </icon-base>
    </div>
    <div class="popover">
      <div class="floating-item popover-item">
        <icon-base icon-name="consult" width="36" height="36" iconColor="#333" iconName="电话咨询">
          <icon-consult />
        </icon-base>
      </div>
      <div class="pop">
        4006-222-312
        <div class="pop-arrow"></div>
      </div>
    </div>

    <div class="floating-item" @click="showLogin">
        <icon-base icon-name="gift" width="36" height="36" iconColor="#333" iconName="免费体验">
          <icon-gift />
        </icon-base>
      </div>
  </div>
</template>
<script>
import IconBase from './IconBase'
import IconConsult from './icons/consult'
import IconChat from './icons/chat'
import IconGift from './icons/gift'

export default {
  created() {
    //this.initBDSQ();
  },
  methods: {
    initBDSQ() {
      let script = document.getElementById('9c408906d3e97fbfeb25a4de995f591c')
      if (script) {
        return;
      }
      var hm = document.createElement('script');
      hm.id = "9c408906d3e97fbfeb25a4de995f591c"
      hm.src = 'https://hm.baidu.com/hm.js?9c408906d3e97fbfeb25a4de995f591c';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s)
    },
    showBDSQ() {
      //this.initBDSQ();
      let dev = document.querySelector("#newBridge #nb_invite_ok")
      if (!dev) {
        return;
      }
      dev.click()
    },
    showLogin() {
      _czc.push(["_trackEvent", "悬浮_按钮_立即体验", "button"]);
      this.$root.$emit('change',true)
    },
    goToAsk(){
      window.location.href = 'http://p.qiao.baidu.com/cps/chat?siteId=48557&userId=82269';
    }
  },
  components: {
    IconBase,
    IconConsult,
    IconChat,
    IconGift
  }
}
</script>
<style lang="less">
.floating {
  position: fixed;
  z-index: 2;
  top: 170px;
  right: 30px;
  display: flex;
  flex-direction: column;

  .floating-item {
    width:60px;
    height:60px;
    padding: 12px;
    margin-bottom: 10px;
    cursor: pointer;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 10px 0px rgba(17,31,44,0.15);
    border-radius:8px;
      &:hover{
        svg g {
          fill: #4285F4;
        }
      }
  }

  .open .floating-item svg g {
    fill: #4285F4;
  }
  .popover{
    position: relative;
    &:hover{
      .pop{
        visibility: visible;
        opacity: 1;
      }
      svg g {
        fill: #4285F4;
      }
    }
    .pop{
      background: #ffffff;
      color: black;
      padding: 24px;
      border-radius: 5px;
      position: absolute;
      left: -188px;
      top: 0px;
      opacity: 0;
      transition: all 0.5s;
      visibility: hidden;
    }
    .pop-arrow{
      width: 0;
      height: 0;
      border: 10px solid;
      border-color: transparent transparent transparent #ffffff;
      position: absolute;
      right: -20px;
      top: 50%;
      transform: translateY(-10px);
    }
  }
}
</style>

<style lang="less">
/* 悬浮工具 */
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  @arrow-size: 10px;

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: @arrow-size;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: @arrow-size;

    .tooltip-arrow {
      border-width: @arrow-size @arrow-size 0 @arrow-size;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -@arrow-size;
      left: calc(50% - @arrow-size);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: @arrow-size;

    .tooltip-arrow {
      border-width: 0 @arrow-size @arrow-size @arrow-size;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -@arrow-size;
      left: calc(50% - @arrow-size);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: @arrow-size;

    .tooltip-arrow {
      border-width: @arrow-size @arrow-size @arrow-size 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -@arrow-size;
      top: calc(50% - @arrow-size);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: @arrow-size;

    .tooltip-arrow {
      border-width: @arrow-size 0 @arrow-size @arrow-size;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -@arrow-size;
      top: calc(50% - @arrow-size);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    @color: rgba(255,255,255,1);
    z-index: 9999;

    .popover-inner {
      background: @color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow:0px 2px 10px 0px rgba(17,31,44,0.15);
    }

    .popover-arrow {
      border-color: @color;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/floating.vue